// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"9d1bfe7a","453":"c2f46ae2","796":"1254693d"}[chunkId] + ".chunk.js";
};